import React, {useEffect, useState} from "react";
import Styles from './styles.module.scss';
import {useDispatch, useSelector} from "react-redux";
import {walletShorter} from "../../helpers/walletShorter";
import {
    getUserAddedWallets,
    setSettingsAddWalletModalStatus,
    setSettingsEditWalletModalStatus
} from "../../store/cabinet/action";
import {useTranslation} from "react-i18next";


const SettingsWallets = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const userData = useSelector(store => store.cabinet.userData);
    const userAddedWallets = useSelector(store => store.cabinet.userAddedWallets);

    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobileView(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    
    useEffect(()=>{
        dispatch(getUserAddedWallets());
    },[dispatch])


    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('Кошельки')}</div>
                <div className={`${Styles.contentWrapNote}`}>{t('Просматривайте и управляйте своими кошельками, транзакциями и финансовыми настройками')}.</div>
                <div className={`${Styles.userWalletWrap}`}>
                    <div className={`${Styles.userWalletTitle}`}>{t('Основной кошелек')}</div>
                    <div className={`${Styles.userWallet}`}>{isMobileView ? walletShorter(userData?.user?.wallet) : userData?.user?.wallet}</div>
                    <div className={`${Styles.userWalletNote}`}>{t('Адрес вашего кошелька установлен навсегда для всех транзакций IDO и не может быть изменён')}.</div>
                </div>
                <div className={`${Styles.addedWalletsWrap}`}>
                    <div className={`${Styles.addedWalletsTitle}`}>{t('Добавленные кошельки')}</div>
                    {userAddedWallets?.wallets?.length > 0 ?
                        <div className={`${Styles.addedWalletsBox}`}>
                            {userAddedWallets?.wallets?.map((item, index)=>{
                                return (
                                    <div className={`${Styles.addedWalletsBoxItem}`} key={'addedWalletsBoxItem' + index}>
                                        <div className={`${Styles.addedWalletsBoxItemImgWrap}`}>
                                            <img src={item.blockchain?.logo} alt={item.blockchain?.name}/>
                                        </div>
                                        <div className={`${Styles.addedWalletsBoxItemWallet}`}>{isMobileView ? walletShorter(item.wallet) : item.wallet}</div>
                                        <div className={`${Styles.addedWalletsBoxItemBtn}`} onClick={()=>{dispatch(setSettingsEditWalletModalStatus({status: true, data: item}))}}>{t('Редактировать')}</div>
                                    </div>
                                )
                            })}
                        </div> : null
                    }
                    {userAddedWallets?.creation_available ?
                        <div
                            className={`${Styles.addedWalletsBtn}`}
                            onClick={()=>{
                                if (userAddedWallets?.creation_available){
                                    dispatch(setSettingsAddWalletModalStatus(true));
                                }
                            }}
                        >
                            {t('Добавить кошелек')}
                        </div> : null
                    }
                </div>
            </div>
        </section>
    );
};

export default SettingsWallets;